import { ListBubble } from '../../ListBubble/ListBubble';
import { PageText } from '../../Text/Text'
import styles from './PortalLeaderBoardRow.module.css'

export const PortalLeaderBoardRow = ({ rank, dimension, metric }) => {
    const formattedMetric = Number(metric).toLocaleString();
    return (
        <div className={styles.rowContainer}>
            <div className={styles.bubbleDimensionGroup}>
               <div>
                    <ListBubble backgroundColor='#EA1917' borderColor='#EA1917' color='white' itemCount={`${rank} `} />
             </div>

                <div className={styles.dimensionText}>
                    <PageText>{dimension}</PageText>
                </div>
            </div>
            <div className={styles.metricText}>
            <PageText>{formattedMetric}</PageText>
                {/* <PageText>{' - '}{formattedMetric}</PageText> */}
            </div>


        </div>
    )
}